import { type UnknownAction } from "redux-saga";
import { combineReducers } from "@reduxjs/toolkit";

import { appSlice } from "./slices/app";
import { userSlice } from "./slices/user";
import { organizationsSlice } from "./slices/organizations";
import { propertiesSlice } from "./slices/properties";
import { workspacesSlice } from "./slices/workspaces";

const appReducer = combineReducers({
   app: appSlice.reducer,
   user: userSlice.reducer,
   organizations: organizationsSlice.reducer,
   properties: propertiesSlice.reducer,
   workspaces: workspacesSlice.reducer,
});

export const rootReduxActions = {
   app: appSlice.actions,
   user: userSlice.actions,
   organizations: organizationsSlice.actions,
   properties: propertiesSlice.actions,
   workspaces: workspacesSlice.actions,
};

export const rootReducer = (state: any, action: UnknownAction) => {
   if (action.type === "app/resetAppState") {
      return appReducer(
         {
            app: state.app,
         },
         action,
      );
   }

   return appReducer(state, action);
};

export type RootReduxActions = typeof rootReduxActions;
